import roles from './lists/roles';
import jobtitles from './lists/jobtitles';
import reportquerytemplates from './lists/reportquerytemplates'

export default {
    namespaced: true,
    state: () => ({
        collection : "Roles",
        searches: [
            { collection: "Roles", value: "" },
            { collection: "Jobtitles", value: "" },
            { collection: "ReportQueryTemplates", value: "" },
        ]
    }),
    mutations: {
        SET_COLLECTION (state, payload) {
            state.collection = payload;
        },
        PUSH_SEARCH (state, payload) {
            let exists = state.searches.find(x => x.collection == state.collection);

            if (exists)
            {
                exists.value = payload.value;
            }
            else
            {
                state.searches.push(payload);
            }
        }
    },
    getters: {
        getCollection (state) {
            return state.collection;
        },
        getSearch (state) {
            return state.searches.find(x => x.collection === state.collection).value;
        }
    },
    modules: {
        roles,
        jobtitles,
        reportquerytemplates
    }
}